import { createSelector } from 'reselect';
import { CLEAR_MODAL_DATA, TOGGLE_MODAL } from './modalActions';
import { getViewStateByName } from '../appViewStates';
import {
    get,
    isEqual
} from 'lodash';

export default function reducer(state = {
    modals: {}
}, action = {}) {
    let newState;

    switch (action.type) {
        case TOGGLE_MODAL: {
            const currentModal = get(state, `modals.${action.uniqueModalName}`, {});

            newState = {
                ...state,
                modals: {
                    ...state.modals,
                    [action.uniqueModalName]: {
                        data: action.data,
                        isOpen: !currentModal.isOpen
                    }
                }
            };

            return isEqual(state, newState) ? state : newState;
        }
        case CLEAR_MODAL_DATA:
            newState = {
                ...state,
                modals: {
                    ...state.modals,
                    [action.uniqueModalName]: {
                        data: null,
                        isOpen: false
                    }
                }
            };

            return isEqual(state, newState) ? state : newState;
        default:
            return state;
    }
}

export const getModalViewState = createSelector(
    (state) => state,
    (state) => getViewStateByName(state, 'modal')
);

export const getModals = createSelector(
    getModalViewState,
    (viewState) => get(viewState, 'modals')
);

export const getModalObjectByUniqueModalName = createSelector(
    getModals,
    (state, uniqueModalName) => (uniqueModalName),
    (modals, uniqueModalName) => get(modals, uniqueModalName)
);

export const getIsOpenByUniqueModalName = createSelector(
    (state, uniqueModalName) => getModalObjectByUniqueModalName(state, uniqueModalName),
    (object) => get(object, 'isOpen')
);

export const getDataByUniqueModalName = createSelector(
    (state, uniqueModalName) => getModalObjectByUniqueModalName(state, uniqueModalName),
    (object) => get(object, 'data')
);
